import { getBrowserTimezone } from "../../../utils/timezone";
import { FREQUENCY_ONE_PER_DAY } from "../../../utils/publishingAutomationFrequency";
import { buildDefaultValidityFields } from "../../../utils/publishingAutomationValidity";

export const AUTOMATION_STEP_SOURCE = 1;
export const AUTOMATION_STEP_PLATFORMS = 2;
export const AUTOMATION_STEP_SCHEDULE = 3;
export const AUTOMATION_STEP_REVIEW = 4;

export const AUTOMATION_SOURCE_ALL = "all";
export const AUTOMATION_SOURCE_FOLDER = "folder";

export const DEFAULT_AUTOMATION_FORM = {
  name: "",
  sourceType: AUTOMATION_SOURCE_FOLDER,
  folderID: "",
  includeSubfolders: true,
  language: "",
  platforms: {},
  frequencyKey: FREQUENCY_ONE_PER_DAY,
  startTime: "08:00",
  endTime: "21:00",
  timezone: getBrowserTimezone(),
  ...buildDefaultValidityFields(),
  startLocked: false,
  lockedActiveFrom: null,
};
